<template>
    <div>
        <v-row class="px-2 pt-2">
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    return-object
                    clearable
                    @change="getReport();"
                    @click:clear="clearMerchant()"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="10"
                    class="elevation-0"
                    show-expand
                >
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            {{ JSON.parse(item.binJson).bins.split(",").join(", ") }}
                        </td>
                    </template>
                    <template v-slot:item.total="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.total) }}
                    </template>
                    <template v-slot:item.successful="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.successful) }}
                    </template>
                    <template v-slot:item.failed="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.failed) }}
                    </template>
                    <template v-slot:item.successRatio="{ item }">
                        {{ item.successRatio }}%
                    </template>
                    <template v-slot:item.failedRatio="{ item }">
                        {{ item.failedRatio }}%
                    </template>
                    <template v-slot:item.failedOtherRatio="{ item }">
                        {{ (100 - (parseFloat(item.successRatio) + parseFloat(item.failedRatio))).toFixed(2) }}%
                    </template>
                    <template v-slot:item.visa="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.visa) }}
                    </template>
                    <template v-slot:item.visaFailedRatio="{ item }">
                        {{ item.visaFailedRatio ? `${item.visaFailedRatio}%` : '-' }}
                    </template>
                    <template v-slot:item.master="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.master) }}
                    </template>
                    <template v-slot:item.masterFailedRatio="{ item }">
                        {{ item.masterFailedRatio ? `${item.masterFailedRatio}%` : '-' }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            merchants: null,
            merchant: {},
            loading: false,
            report: null,
            headers: [{ text: 'Division', value: 'divisionName', sortable: true },
                      { text: 'Merchant', value: 'merchantName', sortable: true },
                      { text: 'Clearing Institute', value: 'clearingInstitute', sortable: false },
                      
                      { text: 'Total', value: 'total', sortable: false, align: "center" },
                      { text: 'Success', value: 'successful', sortable: false, align: "center" },
                      { text: 'Failed', value: 'failed', sortable: false, align: "center" },
                      { text: 'Approval Rate %', value: 'successRatio', sortable: false, align: "center", width: 150 },
                      { text: 'Do Not Honor %', value: 'failedRatio', sortable: true, align: "center", width: 150 },
                    //   { text: 'Failure Other %', value: 'failedOtherRatio', sortable: false, align: "center" },
                      { text: 'Visa', value: 'visa', sortable: false, align: "center" },
                    //   { text: 'Visa Success', value: 'visaSuccess', sortable: false, align: "center" },
                    //   { text: 'Visa Failed', value: 'visaFailed', sortable: false, align: "center" },
                    //   { text: 'Visa Success %', value: 'visaSuccessRatio', sortable: false, align: "center" },
                      { text: 'Visa Failure %', value: 'visaFailedRatio', sortable: false, align: "center" },
                      { text: 'Master', value: 'master', sortable: false, align: "center" },
                    //   { text: 'Master Success', value: 'masterSuccess', sortable: false, align: "center" },
                    //   { text: 'Master Failed', value: 'masterFailed', sortable: false, align: "center" },
                    //   { text: 'Master Success %', value: 'masterSuccessRatio', sortable: false, align: "center" },
                      { text: 'Master Failure %', value: 'masterFailedRatio', sortable: false, align: "center" },
                      { text: 'BINs', value: 'data-table-expand' }]
        }
    },
    beforeMount() {
        this.getMerchants();
        this.getReport();
    },
    methods: {
        getMerchants() {
            axios({
            method: 'get',
            url: `get-merchants-live`,
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.merchants = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getReport() {
            axios({
            method: 'post',
            url: `approval-rates`,
            data: { merchant: typeof this.merchant !== 'undefined' ? this.merchant.name : null },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        clearMerchant() {
            console.log(this.merchant);
        }
    }
}
</script>

<style>
    .v-data-table tbody tr.v-data-table__expanded__content {
        box-shadow: inset 0px 5px 10px -5px rgba(50, 50, 50, 0.1), inset 0px -5px 10px -5px rgba(50, 50, 50, 0.1);
    }
</style>